import { render, staticRenderFns } from "./PrivacyPage.vue?vue&type=template&id=2f7ddeae&scoped=true&"
import script from "./PrivacyPage.vue?vue&type=script&lang=js&"
export * from "./PrivacyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7ddeae",
  null
  
)

export default component.exports